export const DIALOG_ID = {
    CONFIRM: 'dl-confirm',
    CONFIRM_UPDATE: 'dl-confirm-update',
    CHANGE_PWD: 'dl-changepwd',
    JOIN_MEETING: 'dl-join-meeting',
    CREATE_WHITEBOARD: 'dl-create-whiteboard',
    LIMIT_CREATE_WHITEBOARD: 'dl-limit-create-whiteboard',
    IMPORT_USER: 'dl-import-user',
    SEARCH_USER: 'dl-search-user',
    UPDATE_ROLE: 'dl-update-role',
    DELETE_ROLE: 'dl-delete-role',
    RESET_PASSWORD_USER: 'dl-reset-password-user',
    SHOW_PASSWORD_RESETED: 'dl-show-password-reseted',
    CONFIRM_DELETE_USER: 'dl-confirm-delete-user',
    REJECT_INVITE: 'dl-reject-invite',
    MEETING_NOW: 'dl-meeting-now',
    EDIT_IMAGES: 'dl-edit-images',
    DELETE_AVATAR: 'dl-delete-avatar',
    ADD_CONFIG: 'dl-add-config',
    EDIT_ROLE_ITEM: 'dl-edit-role-item',
    CONFIRM_UNASSIGN_USER: 'dl-unassign-user',
    CONFIRM_ASSIGN_USER: 'dl-assign-user',
    CONFIRM_ASSIGN_TO_ME: 'dl-assign-to-me',
    ADD_ACCOUNT_ROLE: 'dl-add-account-role',
    CREATE_OR_UPDATE_ROLE: 'dl-create-or-update-role',
    EVENT: 'dl-event',
    CONFIRM_DELETE_EVENT: 'dl-confirm-delete-event',
    ACCEPT_INVITE_MAIN_PACKAGE: 'dl-accept-invite-main-package',
    ACCEPT_INVITE_ADDON_PACKAGE: 'dl-accept-invite-addon-package',
    REJECT_INVITE_PACKAGE: 'dl-reject-invite-package',
    WARNING_LICENSE_ROOM: 'dl-warning-license-room',
    LIMIT_TOTAL_MEETING_HOST: 'dl-limit-total-meeting-host',
    LIMIT_TOTAL_MEETING: 'dl-limit-total-meeting',
    PROVIDE_SERVICE: 'dl-provide-service',
    LIMIT_ACCESS: 'dl-limit-access',
    EXPIRE_SERVICE: "dl-expire-service",
    EXPIRED_SERVICE: "dl-expired-service",
    LIMIT_CREATE: 'dl-limit-create',
    INVITE_USE_SHARED_STORAGE: "dl-invite-use-share-storange",
    ABOUT: 'dl-about-infomation',
    CONFIRM_ENCRYPTED_TOKEN: 'dl-confirm-encrypted-token',
    EDIT_BACKUP: 'dl-edit-backup',
    CONFIRM_DELETE_BACKUP: 'dl-confirm-delete-backup',
    CONFIRM_REFRESH_TOKEN: 'dl-confirm-refresh-token',
    CONFIRM_CHANGE_PORT: 'dl-confirm-change-port',
    CREATE_MCU_ROOM: 'dl-create-mcu-room',
    CREATE_SIP_USER: 'dl-create-sip-user',
    CREATE_OR_UPDATE_MCU_DEVICE: "dl-create-or-update-mcu-device",
    ADD_UNIT: 'dl-add-unit',
    SEARCH_UNIT: 'dl-search-unit'
}